module.exports = __webpack_public_path__ + "img/newSmBtnIcon.ab2bb749.svg";